var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SearchableDocumentsList", {
    attrs: {
      query: _vm.query,
      companyId: _vm.companyId,
      outerFilterTouched: _vm.filtersTouched,
      currentUser: _vm.currentUser,
    },
    scopedSlots: _vm._u([
      {
        key: "filters",
        fn: function () {
          return [
            _c("ProjectsMultiselect", {
              staticClass: "documents__multiselect",
              attrs: {
                value: _vm.chosenProjectsIds,
                placeholder: "Select clients",
                selectedInline: "",
              },
              on: { input: _vm.onProjectSelected },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }